import { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils/css/cn';

export interface ProductTitleProps extends HTMLAttributes<HTMLDivElement> {
	children?: ReactNode;
}

export const ProductTitle = ({ children, className, ...restProps }: ProductTitleProps) => {
	if (!children) return null;

	return (
		<h2
			className={cn(
				'text-lg w-full py-0 mt-0 mb-5 lg:mb-6 font-medium pb-0! border-none! normal-case',
				className,
			)}
			{...restProps}
			data-tid="product-title"
		>
			{children}
		</h2>
	);
};
